import { api } from '@/constants'
import { getAuthHeader } from '@/util'
import baseURL from '@/service/api'

const notification = {
  notif: (payloads) => {
    const url = api.notification.notif
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
}

export default notification
